import { render, staticRenderFns } from "./OrganizationDetailsForm.vue?vue&type=template&id=1c28286e&scoped=true&"
import script from "./OrganizationDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./OrganizationDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationDetailsForm.vue?vue&type=style&index=0&id=1c28286e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28286e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c28286e')) {
      api.createRecord('1c28286e', component.options)
    } else {
      api.reload('1c28286e', component.options)
    }
    module.hot.accept("./OrganizationDetailsForm.vue?vue&type=template&id=1c28286e&scoped=true&", function () {
      api.rerender('1c28286e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/OrganizationDetailsForm.vue"
export default component.exports